import { defineStore } from 'pinia'
import { ref } from 'vue'
import { useApiFetch } from '@/api'

// A store, not a module ref: the server render shares module state across concurrent requests.
export const useApiFailureStore = defineStore('apiFailure', () => {
  const broken = ref(false)

  const clear = () => {
    broken.value = false
  }

  // Cast because `types: ["bun"]` puts `preconnect` on `typeof fetch`, and a strand has no business carrying it.
  useApiFetch().use(
    next =>
      (async (input, init) => {
        try {
          const response = await next(input, init)
          if (response.status >= 500) broken.value = true
          return response
        } catch (cause) {
          if (!init?.signal?.aborted) broken.value = true
          throw cause
        }
      }) as typeof fetch
  )

  return { broken, clear }
})
